import StructureModel from "./StructureModel";
import CRMModel from "./CRMModel";

export default class ProstateModel extends StructureModel {
    get prostateAxes() {
        return this._prostateAxes;
    }

    get crm() {
        return this._crm;
    }

    initProstateAxes(prostateAxes) {
        if (!this._meshViewer) {
            return;
        }

        this._prostateAxes = prostateAxes;
        this._prostateAxes.meshViewer = this._meshViewer;
        this._prostateAxes.initializeView(this);
    }

    initializeViewFromGeometry(geometry, options) {
        super.initializeViewFromGeometry(geometry, options);

        if (!this.mriViewer) {
            return;
        }

        // create the CRM model from geometry of this model
        this._crm = new CRMModel(this);
    }
}
